import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
document.documentElement.style.backgroundColor = process.env.REACT_APP_MAIN_COLOR;
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
